import * as tslib_1 from "tslib";
var QueryState_1;
import { State, Action, Store, Selector } from '@ngxs/store';
const category = 'Query';
export class SetAvailableSpanTypes {
    constructor(spanTypes) {
        this.spanTypes = spanTypes;
    }
}
SetAvailableSpanTypes.type = `[${category}] ChangeStatus`;
export class SetSelectedSpanTypes {
    constructor(SelectedSpanType) {
        this.SelectedSpanType = SelectedSpanType;
    }
}
SetSelectedSpanTypes.type = `[${category}] SetSelectedSpanTypes`;
let QueryState = QueryState_1 = class QueryState {
    constructor(store) {
        this.store = store;
    }
    // available spans state
    static availableSpanTypes(state) {
        return state.availableSpanTypes;
    }
    setAvailableSpanTypes(ctx, action) {
        ctx.patchState({
            availableSpanTypes: action.spanTypes,
        });
    }
    // selected spans state
    static selectedSpanTypes(state) {
        return state.selectedSpanTypes;
    }
    setSelectedSpanTypes(ctx, action) {
        ctx.patchState({
            selectedSpanTypes: action.SelectedSpanType,
        });
    }
    getAvailableSpanTypes() {
        return this.store.selectSnapshot(QueryState_1.availableSpanTypes);
    }
    getSelectedSpanTypes() {
        return this.store.selectSnapshot(QueryState_1.selectedSpanTypes);
    }
};
tslib_1.__decorate([
    Action(SetAvailableSpanTypes),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, SetAvailableSpanTypes]),
    tslib_1.__metadata("design:returntype", void 0)
], QueryState.prototype, "setAvailableSpanTypes", null);
tslib_1.__decorate([
    Action(SetSelectedSpanTypes),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, SetSelectedSpanTypes]),
    tslib_1.__metadata("design:returntype", void 0)
], QueryState.prototype, "setSelectedSpanTypes", null);
tslib_1.__decorate([
    Selector([QueryState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], QueryState, "availableSpanTypes", null);
tslib_1.__decorate([
    Selector([QueryState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], QueryState, "selectedSpanTypes", null);
QueryState = QueryState_1 = tslib_1.__decorate([
    State({
        name: 'query',
        defaults: {
            availableSpanTypes: [],
            selectedSpanTypes: ['ALL'],
        },
    }),
    tslib_1.__metadata("design:paramtypes", [Store])
], QueryState);
export { QueryState };
